module.exports = __webpack_public_path__ + "img/map.3c4165b9.png";